<template>
  <div class='' style="width:100%;height:100%;">
    <div :ref="`live${index}`" :id="'playercontainer_'+index"></div>
  </div>
</template>

<script>
import "cyberplayer";
export default {
  name: "",
  props: {
    index: {
      type: Number,
      default: 0
    },
    urlList: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
			player: Function,
			list:[]
    };
  },
  components: {},
  created() {
		console.log('hhaurlList',this.urlList)
	},
  mounted() {
		this.$nextTick(()=>{
			console.log('this.urlList',this.urlList)
			// this.urlList.forEach((item, index) => {
      this.baiduMp4(this.index, this.urlList.rtsp, "");
    // });
		})
	},
  methods: {
    baiduMp4(id, mp4Url, imgUrl) {
      // 这里前面是用var声明的player，现在把player直接存在data()里面
      setTimeout(() => {
        this.player = cyberplayer("playercontainer_" + id).setup(
          {
            width: "100%", // 宽度，也可以支持百分比(不过父元素宽度要有)
            height: "100%", // 高度，也可以支持百分比
            title: "基本功能", // 标题
            file: mp4Url,
            // "http://cmgw-vpc.lechange.com:8888/LCO/5H09C69PAGB57E7/0/0/20200530T061449/dev_5H09C69PAGB57E7_20200530T061449.m3u8", // 播放地址
            image: "", // 预览图
            autostart: true, // 是否自动播放
            stretching: "uniform", // 拉伸设置
            repeat: false, // 是否重复播放
            volume: 100, // 音量
            controls: true, // controlbar是否显示
            starttime: 0, // 视频开始播放时间点(单位s)，如果不设置，则可以从上次播放时间点续播
            logo: {
              // logo设置
              linktarget: "_blank",
              margin: 8,
              hide: false,
              position: "top-right", // 位置
              file: "./img/bf_logo.png" // 图片地址
            },
            ak: "39f82ac87fc3462ea4dcc78734450f57" // 公有云平台注册即可获得accessKey
          },
          150
        );
      });
      // this.playComplete();
      // this.player.remove();
    }
  },
  // 实例销毁之前清除player方法，停止播放
  beforeDestroy() {
    // this.player.remove();
  },
  destroyed() {
    this.$off();
    this.$destroy();
	},
	computed:{},
  watch: {
    urlList: {
      handler(newVal, oldVal) {
				//  this.player.remove();
				//  oldVal.forEach((item, index) => {
        //     this.baiduMp4(index, '', "");
				// 	});
					this.baiduMp4(this.index, '', "");
        // if (newVal.length > 0) {
					this.$nextTick(()=>{
          // newVal.forEach((item, index) => {
            this.baiduMp4(this.index, newVal.rtsp, "");
					// });
					})
        // }
      },
      deep: true
    }
  }
};
</script>
<style lang='scss' scoped>
</style>
